<template>
  <div>
    <ProductPageModule
      :data="document.data"
      data-luko-tracking="Page-Products_slug"
    />
  </div>
</template>

<script>
import { formatMetaDatas } from '~/utils/metaData'
import ProductPageModule from '~/modules/ProductPage'
import {
  getNavCtaLinkByTagName,
  getNavCtaLinkByProductUid,
} from '~/utils/navbarCta'

export default {
  name: 'CategoryPage',

  head() {
    // Get data from heroSlice
    const heroData = this.document.data.body.find(
      ({ slice_type }) => slice_type === 'hero'
    )
    if (!heroData) return []

    const { title, subtitle, backgroundImage } = heroData.primary
    const defaultMeta = {
      open_graph_title: title[0]?.text || '',
      open_graph_description: subtitle[0]?.text || '',
      open_graph_image: backgroundImage?.url || '',
      open_graph_type: 'article',
      twitter_title: title[0]?.text || '',
      twitter_description: subtitle[0]?.text || '',
      twitter_image: backgroundImage?.url || '',
    }
    return formatMetaDatas(this.metaDatas, this.$route.path, defaultMeta)
  },

  jsonld() {
    const heroData = this.document.data.body.find(
      ({ slice_type }) => slice_type === 'hero'
    )
    const name = heroData?.primary?.title[0].text
    const description = heroData?.primary?.subtitle[0].text
    const image = [heroData?.primary?.backgroundImage?.url || '']

    const microdataSlice = this.document.data.body2.find(
      ({ slice_type }) => slice_type === 'microdata'
    )
    const lowPrice = microdataSlice?.primary.low_price.toString()

    return {
      '@context': 'https://schema.org/',
      '@type': 'Product',
      name,
      image,
      description,
      brand: {
        '@type': 'Brand',
        name: 'Luko',
        logo: 'https://luko.cdn.prismic.io/luko/ab601311-bb31-4cfe-a17e-70c4eec37553_Logo.svg',
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.5',
        ratingCount: '989',
      },
      offers: {
        '@type': 'AggregateOffer',
        offerCount: '',
        lowPrice,
        highPrice: '',
        priceCurrency: 'EUR',
      },
    }
  },

  components: {
    ProductPageModule,
  },

  async asyncData({ app, $prismic, store, params, error }) {
    try {
      const document = await $prismic.api.getByUID(
        'product_page',
        params.slug,
        {
          lang: app.i18n.localeProperties.prismicIso,
        }
      )

      if (document.uid !== params.slug)
        throw new Error("slug doesn't match with uid")

      store.dispatch('setAlternateLanguages', document.alternate_languages)

      document.data.body = document.data.body.map((slice) => {
        if (slice.slice_type !== 'article_anchor') return slice

        slice.items = document.data.body1
        return slice
      })

      // Extract page settings from PageSettings slice.
      store.commit(
        'page/UPDATE',
        document.data.body.find((s) => s.slice_type === 'page_settings')
      )
      document.data.body = document.data.body.filter(
        (s) => s.slice_type !== 'page_settings'
      )
      const navCta =
        document.tags?.length > 1
          ? getNavCtaLinkByTagName(document.tags, app.i18n.localeProperties.iso)
          : getNavCtaLinkByProductUid(document.uid)
      store.commit('SET_NAV_CTA', navCta)

      return {
        alternate_languages: document.alternate_languages,
        document,
        metaDatas: document.data.body2 || [],
      }
    } catch (e) {
      error({ statusCode: 500, message: 'Error in asyncData' })
    }
  },
}
</script>

<style></style>
